//@ts-nocheck
import {
  Box,
  Flex,
  HStack,
  Image,
  Stack,
  Grid,
  Heading,
  Link,
  Text,
  BoxProps,
} from "@chakra-ui/react";
import * as React from "react";
import { FaStar } from "react-icons/fa";

const Rating = (props) => {
  const { value = 5, ...rest } = props;
  return (
    <Stack isInline align="center" {...rest}>
      {Array.from({
        length: 5,
      }).map((_, i) => {
        const fade = i + 1 > value;
        return (
          <Box
            as={FaStar}
            color={fade ? "whiteAlpha.500" : "gold.400"}
            fontSize="xl"
            key={i}
          />
        );
      })}
    </Stack>
  );
};
interface TestimonialProps extends BoxProps {
  company: string;
  name: string;
}
export const Testimonial: React.FC<TestimonialProps> = ({
  company,
  name,
  children,
  ...rest
}) => {
  return (
    <Stack
      spacing={6}
      h="100%"
      rounded="fbRadius"
      shadow="fbShadow"
      p={{
        base: "6",
        md: "12",
      }}
      bg="white"
      color="gray.800"
      {...rest}
    >
      <Box
        fontSize={{
          base: "md",
          md: "lg",
        }}
        flex="1"
      >
        {children}
      </Box>
      <Stack
        isInline
        align="center"
        spacing={{
          base: 3,
          md: 5,
        }}
      >
        {/* <Image
          objectFit="cover"
          rounded="full"
          height={12}
          width={12}
          name={name}
          src={image}
        /> */}
        <Flex direction="column">
          <Text fontWeight="bold">{name}</Text>
          <Text fontSize="sm" fontWeight="medium" opacity={0.7}>
            {company}
          </Text>
        </Flex>
      </Stack>
    </Stack>
  );
};

export const PricingTestimonial = () => {
  return (
    <Box as="section" bg="blue.900" color="white" py="6rem">
      <Box
        maxW={{
          base: "xl",
          md: "1560px",
        }}
        mx="auto"
        px={{
          base: "6",
          md: "8",
        }}
        py="10"
      >
        <Grid
          templateColumns={{
            base: "1fr",
            lg: "460px 1fr",
          }}
          gap={{
            base: "10",
            lg: "8",
          }}
        >
          <Box>
            <Text
              textTransform="uppercase"
              fontWeight="semibold"
              color="gold.400"
              fontSize={["sm", "md"]}
              letterSpacing="wide"
            >
              Trusted by 8,600+ families
            </Text>
            <Heading
              as="h3"
              color="white"
              fontSize={["5xl", "6xl"]}
              fontWeight={"black"}
              mt="8"
              lineHeight="shorter"
            >
              Hear from our customers
            </Heading>
            <Rating mt="10" value={5} />
            <Text mt="4">
              <b>9.2/10</b> rating from parents
            </Text>
          </Box>
          <Stack
            spacing={8}
            maxW={{
              base: "unset",
              lg: "37.5rem",
            }}
            mx="auto"
          >
            <Testimonial
              name="Mrs. Nypha Daniels"
              company="Mom of Preschooler in Lekki, Lagos"
            >
              My daughter's teacher, Florence, does pay attention to the
              academic need of the child, supports in assignment, has a time
              table that she follows and accords the child break when required.
              In all, Florence is a teacher who knows how to relate with a child
              and who has a proper method of teaching and follows a progressive
              method. I am interested in still working with Florence and Tuteria
              for continued progress with my child.
            </Testimonial>
          </Stack>
        </Grid>
      </Box>
    </Box>
  );
};
